import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { FormField, ConnectionCheckOptions } from '../../types/form';

interface ConnectionCheckFieldEditorProps {
  editedField: FormField;
  onFieldChange: (updates: Partial<FormField>) => void;
}

export const ConnectionCheckFieldEditor: React.FC<ConnectionCheckFieldEditorProps> = ({
  editedField,
  onFieldChange,
}) => {
  const options = (editedField.options || {}) as ConnectionCheckOptions;

  const update = (key: keyof ConnectionCheckOptions, raw: string) => {
    const parsed = parseFloat(raw);
    onFieldChange({
      options: {
        ...editedField.options,
        [key]: Number.isNaN(parsed) ? undefined : parsed,
      },
    });
  };

  return (
    <div className="grid grid-cols-3 gap-4">
      <div>
        <Label htmlFor={`minDownMbps-${editedField.id}`}>Min download (Mbps)</Label>
        <Input
          id={`minDownMbps-${editedField.id}`}
          type="number"
          min="0"
          step="0.5"
          value={options.minDownMbps ?? 3}
          onChange={(e) => update('minDownMbps', e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`minUpMbps-${editedField.id}`}>Min upload (Mbps)</Label>
        <Input
          id={`minUpMbps-${editedField.id}`}
          type="number"
          min="0"
          step="0.5"
          value={options.minUpMbps ?? 2}
          onChange={(e) => update('minUpMbps', e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`maxRttMs-${editedField.id}`}>Max latency (ms)</Label>
        <Input
          id={`maxRttMs-${editedField.id}`}
          type="number"
          min="0"
          step="10"
          value={options.maxRttMs ?? 250}
          onChange={(e) => update('maxRttMs', e.target.value)}
        />
      </div>
    </div>
  );
};
